import { TYPE_ENTITY } from './entities'

export enum NonProfitEntity {
  ASSOCIATIONS = 'B1',
  FOREIGN_ASSOCIATIONS = 'B2',
  CONSORTIUMS = 'B3',
  COOPERATIVES_CONFEDERATIONS = 'B4',
  FOUNDATIONS = 'B5',
  CHURCHES = 'B6',
  NON_GOVERNMENTAL_ORGANIZATIONS = 'B7',
  POLITICAL_ORGANIZATIONS = 'B8',
  TRUSTS = 'B9',
  UNIONS = 'B10',
  UNIVERSITIES = 'B11',
  OTHER = 'B12'
}

export const NON_PROFIT_ENTITY = {
  ASSOCIATIONS: 'B1',
  FOREIGN_ASSOCIATIONS: 'B2',
  CONSORTIUMS: 'B3',
  COOPERATIVES_CONFEDERATIONS: 'B4',
  FOUNDATIONS: 'B5',
  CHURCHES: 'B6',
  NON_GOVERNMENTAL_ORGANIZATIONS: 'B7',
  POLITICAL_ORGANIZATIONS: 'B8',
  TRUSTS: 'B9',
  UNIONS: 'B10',
  UNIVERSITIES: 'B11',
  OTHER: 'B12'
} as const

export const NAME_NON_PROFIT_ENTITY = {
  B1: 'ASOCIACIONES',
  B2: 'ASOCIACIONES EXTRANJERAS',
  B3: 'CONSORCIOS',
  B4: 'COOPERATIVAS Y CONFEDERACIONES',
  B5: 'FUNDACIONES',
  B6: 'IGLESIAS',
  B7: 'ORGANIZACIONES NO GUBERNAMENTALES',
  B8: 'ORGANIZACIONES POLÍTICAS',
  B9: 'PATRONATOS',
  B10: 'SINDICATOS',
  B11: 'UNIVERSIDADES',
  B12: 'OTRA'
} as const

export const CATALOG_NON_PROFIT_ENTITY = [
  {
    value: NON_PROFIT_ENTITY.ASSOCIATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B1
  },
  {
    value: NON_PROFIT_ENTITY.FOREIGN_ASSOCIATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B2
  },
  {
    value: NON_PROFIT_ENTITY.CONSORTIUMS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B3
  },
  {
    value: NON_PROFIT_ENTITY.COOPERATIVES_CONFEDERATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B4
  },
  {
    value: NON_PROFIT_ENTITY.FOUNDATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B5
  },
  {
    value: NON_PROFIT_ENTITY.CHURCHES,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B6
  },
  {
    value: NON_PROFIT_ENTITY.NON_GOVERNMENTAL_ORGANIZATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B7
  },
  {
    value: NON_PROFIT_ENTITY.POLITICAL_ORGANIZATIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B8
  },
  {
    value: NON_PROFIT_ENTITY.TRUSTS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B9
  },
  {
    value: NON_PROFIT_ENTITY.UNIONS,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B10
  },
  {
    value: NON_PROFIT_ENTITY.UNIVERSITIES,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B11
  },
  {
    value: NON_PROFIT_ENTITY.OTHER,
    type: TYPE_ENTITY.NON_PROFIT_ENTITY,
    label: NAME_NON_PROFIT_ENTITY.B12
  }
]
